import { Directive, Input, HostListener, Inject } from '@angular/core';
import { AnalyticsService } from '../analytics.service';
import { TrackBase } from '../track-base/track-base.directive';
import { DOCUMENT } from '@angular/common';

@Directive({
  selector: '[appTrackClick]',
  standalone: false,
})
export class TrackClickDirective extends TrackBase {
  /** Required */
  @Input('appTrackClick') buttonName!: string;

  /** Required */
  @Input() screenName!: string;

  /** Optional */
  @Input() ctaType: 'primary' | 'secondary' = 'secondary';

  constructor(
    analytics: AnalyticsService,
    @Inject(DOCUMENT) document: Document,
  ) {
    super(analytics, document);
  }

  @HostListener('click')
  onClick() {
    if (!this.buttonName) return;

    this.track('button_click', {
      button_name: this.buttonName,
      screen_name: this.resolveScreenName(this.screenName),
      cta_type: this.ctaType,
    });
  }
}
